module.exports = __webpack_public_path__ + "files/90449d70260d76a807b92c72ea04d36e.png";